import * as React from "react";
const Close = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 6 6", fill: "currentColor", width: size || "6", height: size || "6", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.2 0 3 2.2.8 0 0 .8 2.2 3 0 5.3.8 6 3 3.8 5.2 6 6 5.3 3.8 3 6 .8z" }));
Close.displayName = "Close";
var Close_default = Close;
export {
  Close_default as default
};
